import { View } from 'react-native'

export const FeedFooterItem = () => (
  <View
    style={{
      paddingVertical: 16,
    }}
  />
)
